<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<FormItem prop="OperatorId">
					<Input style="width: 200px;" type="text" v-model="formInline.OperatorId" placeholder="运营商ID">
					<span slot="prepend">运营商Id</span>
					</Input>
				</FormItem>
				<FormItem prop="OperatorName">
					<Input style="width: 200px;" type="text" v-model="formInline.OperatorName" placeholder="运营商名称">
					<span slot="prepend">运营商名称</span>
					</Input>
				</FormItem>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">运营商添加</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<!-- <Table :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getOperatorInfoUrl" @listData='getDeviceData'></MyPage>
		</Table> -->
		<PageTable ref="table" :columns="columns1" :tableHeight="tableHeight" :url="getOperatorInfoUrl" :queryParam="pageParam"></PageTable>
		<Modal :mask-closable="false" v-model="modalView" :title="modal.Title" width="60%">
			<!--安装和修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="AddUpForm" :model="StationForm"
				:label-width="120">
				<FormItem label="运营商ID" prop="OperatorId">
					<Input :disabled="ifup" v-model="StationForm.OperatorId" placeholder="留空则随机生成字符串"></Input>
				</FormItem>
				<FormItem label="运营商名称" prop="OperatorName">
					<Input :disabled="ifViewStation" v-model="StationForm.OperatorName" placeholder="输入运营商名称"></Input>
				</FormItem>
				<!-- <FormItem label="运营商电话" prop="OperatorTel1">
					<Input :disabled="ifViewStation" v-model="StationForm.OperatorTel1" placeholder="运营商电话"></Input>
				</FormItem> -->
				<FormItem label="充电站名称" prop="StationName">
					<Input :disabled="!ifAddStation" v-model="StationForm.StationName" placeholder="用于创建充电站"></Input>
				</FormItem>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
			<div v-if="modal.type=='update'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">确认修改</Button>
			</div>
			<div v-if="modal.type=='view'" slot="footer">
			</div>
		</Modal>
		<!-- <Modal :z-index="zindex" v-model="showMap" :title="modal.Title" width="40%">
			<div id="map" style="width: 100%;height: 300px;"></div>
			<div slot="footer">
				<Button type="success" size="small" @click="closeMap">关闭</Button>
			</div>
		</Modal> -->
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import PageTable from '../../public/PageTable/PageTable.vue';
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			PageTable
		},
		data() {
			// const validateOpId = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error('输入运营商Id'));
			// 	} else {
			// 		if (this.StationForm.OperatorId.length < 9) {
			// 			callback(new Error('社会信用代码不少于9位'));
			// 		} else if (this.StationForm.OperatorId.length > 20) {
			// 			callback(new Error('社会信用代码不多于20位'));
			// 		} else {
			// 			callback();
			// 		}
			// 	}
			// };
			return {
				getOperatorInfoUrl: webapi.base_api_url + '/Archives/GetOperatorInfo',
				// uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				zindex: 2000,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				// //选择展示的充电站
				// SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "运营商添加",
					type: "addOperator"
				},
				//修改添加moda
				modalView: false,
				//图片modal
				showPictures: false,
				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],
				//图片地址数组
				StationPicturesArray: [],
				/******分割线********/

				//地图modal
				center: [114.198595, 22.633595],
				showMap: false,

				//字段显示
				ifAddStation: true,

				//修改不能修改id
				ifup: false,
				//场站信息是否只能查看
				ifViewStation: false,
				//档案-场站管理全部信息
				StationForm: {
					"OperatorId": "",
					"Type": 99,
					"OperatorName": "",
					"Enable": 0,
					"MerchantId": 0,
					"PaymentMode": 0,
					"OperatorTel1": "",
					"OperatorTel2": "",
					"OperatorRgeAddress": "",
					"Remark": "",
					"CreateBy": 0,
					"CreateTime": "2022-03-13T08:29:55.002Z",
					"ModifyBy": 0,
					"ModifyTime": "2022-03-13T08:29:55.002Z",
					"LogoTitle": "",
					"LogoImg": "",
					"ShortName": "",
					"IcpNo": "",
					"DomainName": "",
					"Creator": "",
					"Modifier": "",
					"IsEdit": false
				},
				//校验字段
				ruleInline: {
					// OperatorId: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					// Type: [{
					// 	required: true,
					// 	message: '运营商类型',
					// 	trigger: 'change',
					// 	type: 'number'
					// }],
					OperatorName: [{
						required: true,
						message: '运营商名称',
						trigger: 'blur'
					}],
					// OperatorTel1: [{
					// 	required: true,
					// 	message: '运营商电话1',
					// 	trigger: 'blur'
					// }],
					// LogoTitle: [{
					// 	required: true,
					// 	message: '平台显示标题',
					// 	trigger: 'blur'
					// }]
					// DomainName: [{
					// 	required: true,
					// 	message: '域名',
					// }],
				},
				BreadcrumbList: ['档案管理', '>>', '运营商管理'],
				formInline: {
					OperatorId: '',
					OperatorName: '',
				},
				//table标题数据
				columns1: [{
						title: '运营商ID',
						key: 'OperatorId',

					}, {
						title: '运营商名称',
						key: 'OperatorName',

					},
					// {
					// 	title: '运营商电话1',
					// 	key: 'OperatorTel1',
					// },
					// {
					// 	title: '运营商电话2',
					// 	key: 'OperatorTel2',
					// 	width: 120
					// },
					// {
					// 	title: '平台显示标题',
					// 	key: 'LogoTitle',
					// 	width: 200
					// },
					// {
					// 	title: '平台显示logo图片',
					// 	key: 'LogoImg',
					// 	width: 200,
					// 	render: (h, params) => {
					// 		let url = ''
					// 		// if (process.env.NODE_ENV === "development") {
					// 		// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+(params.row.LogoImg.split(","))[0];
					// 		// }else {
					// 		//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+(params.row.LogoImg.split(","))[0];
					// 		// }
					// 		url = webapi.base_api_url + (params.row.LogoImg.split(","))[0];
					// 		let arr = [];
					// 		if (params.row.LogoImg == "" || params.row.LogoImg == undefined) {
					// 			arr.push(
					// 				h('div', "未上传"))
					// 		} else {
					// 			arr.push(
					// 				h('div', [
					// 					h('img', {
					// 						style: {
					// 							width: "40px",
					// 							height: "40px",
					// 							verticalAlign: "middle",
					// 							borderRadius: "50%"
					// 						},
					// 						attrs: {
					// 							src: url
					// 							//src: "ChargePlatform/"+(params.row.LogoImg.split(","))[0]
					// 						}
					// 					})
					// 				])
					// 			)
					// 		}
					// 		return arr;
					// 		// return h('div',
					// 		// 	params.row.LogoImg
					// 		// );
					// 	}
					// },
					// {
					// 	title: 'ICP备案信息',
					// 	key: 'IcpNo',
					// 	width: 200
					// },
					// {
					// 	title: '域名列表',
					// 	key: 'DomainName',
					// 	width: 300
					// },
					{
						title: '操作',
						key: 'action',
						width: 135,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row.OperatorId)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show("view", params.row.OperatorId)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '查看') : h(),
								// h('Dropdown', {
								// 		on: {
								// 			//为了不误操作，确定取消相反
								// 			'on-click': (name) => {
								// 				this.$Modal.confirm({
								// 					title: name,
								// 					okText: '取消',
								// 					cancelText: '确定',
								// 					onCancel: () => {
								// 						this.otherMethodStation(name, params.row.Id);
								// 					}
								// 				});
								// 				// this.show("deleteStation", params.row.Id)
								// 			}
								// 		}
								// 	},
								// 	[
								// 		h('Button', {
								// 			props: {
								// 				type: 'primary',
								// 				size: 'small',
								// 			},
								// 			style: {
								// 				marginRight: '5px'
								// 			},
								// 		}, '其他操作'),
								// 		h('DropdownMenu', {
								// 			slot: 'list'
								// 		}, [
								// 			this.methodList.map((item) => { // this.productTypeList下拉框里的data
								// 				return h('DropdownItem', {
								// 						props: {
								// 							name: item.Status
								// 						}
								// 					},
								// 					item.Status
								// 				)
								// 			})
								// 		])
								// 	],
								// )
							]);
						}
					}
				],
				// methodList: [{
				// 		id: 1,
				// 		Status: '建设中'
				// 	}, {
				// 		id: 5,
				// 		Status: '关闭下线'
				// 	},
				// 	{
				// 		id: 6,
				// 		Status: '维护中'
				// 	},
				// 	{
				// 		id: 50,
				// 		Status: '正常使用'
				// 	}
				// ],
				data1: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight()
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					OperatorId: _this.formInline.OperatorId,
					OperatorName: _this.formInline.OperatorName
				}
				return param
			},
			// PayMethod1: {
			// 	get() {
			// 		let pay = this.StationForm.PaymentMode.toString(2);
			// 		while (pay.length < 6) {
			// 			pay = '0' + pay;
			// 		}
			// 		console.log(pay)
			// 		console.log(pay.substring(5, 6))
			// 		return Number(pay.substring(5, 6))
			// 	},
			// 	set(value) {
			// 		if (value == 0) {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode - 1;
			// 		} else {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode + 1;
			// 		}
			// 	}
			// },
			// PayMethod2: {
			// 	get() {
			// 		let pay = this.StationForm.PaymentMode.toString(2);
			// 		while (pay.length < 6) {
			// 			pay = '0' + pay;
			// 		}
			// 		return Number(pay.substring(4, 5))
			// 	},
			// 	set(value) {
			// 		if (value == 0) {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode - 2;
			// 		} else {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode + 2;
			// 		}
			// 	}
			// },
			// PayMethod3: {
			// 	get() {
			// 		let pay = this.StationForm.PaymentMode.toString(2);
			// 		while (pay.length < 6) {
			// 			pay = '0' + pay;
			// 		}
			// 		return Number(pay.substring(1, 2))
			// 	},
			// 	set(value) {
			// 		if (value == 0) {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode - 16;
			// 		} else {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode + 16;
			// 		}
			// 	}
			// },
			// PayMethod4: {
			// 	get() {
			// 		let pay = this.StationForm.PaymentMode.toString(2);
			// 		while (pay.length < 6) {
			// 			pay = '0' + pay;
			// 		}
			// 		return Number(pay.substring(0, 1))
			// 	},
			// 	set(value) {
			// 		if (value == 0) {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode - 32;
			// 		} else {
			// 			this.StationForm.PaymentMode = this.StationForm.PaymentMode + 32;
			// 		}
			// 	}
			// },
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			...mapActions([
				'GetTypeListDefine',
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = "运营商添加";
						this.ifup = false
						this.ifViewStation = false;
						this.ifAddStation = true;
						this.modalCancel();
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "运营商添加信息修改";
						this.ifup = true
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.ifViewStation = false;
						this.ifAddStation = false;
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = "运营商信息查看";
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.ifViewStation = true
						this.ifAddStation = false;
						this.ifup = true
						break;
				}
				this.modalView = true;
			},
			//modal取消操作
			// cancelPictures: function() {
			// 	const _this = this
			// 	_this.PictureUpCache = []
			// 	if (_this.PictureDelCache.length > 0) {
			// 		console.log("取消添加或更新modal，删除添加的缓存图片")
			// 		let picsArr = _this.PictureDelCache
			// 		let StationPictures = ''
			// 		for (let i = 0; i < picsArr.length; i++) {
			// 			if (i == (picsArr.length - 1)) {
			// 				StationPictures += picsArr[i]
			// 			} else {
			// 				StationPictures += picsArr[i] + ','
			// 			}
			// 		}
			// 		_this.deletePicture(StationPictures)
			// 	}
			// },
			//删除修改之外的其他操作
			// otherMethodStation: function(name, Id) {
			// 	let typeNum = (this.methodList.filter(function(item, index, arr) {
			// 		return item.Status == name
			// 	})[0]).id
			// 	console.log(typeNum)
			// 	this.$axios.post(webapi.base_api_url + "/Archives/SetStationStatus2222", {
			// 		Id: Id,
			// 		Status: typeNum
			// 	}).then(res => {
			// 		if (res.data.code == 0) {
			// 			this.$Message.info(name + '成功');
			// 		}
			// 	})
			// },
			// deleteStation: function() {
			// 	const _this = this;
			// 	_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
			// 		if (res.data.code != 1 && res.data.Data != null) {
			// 			this.$Message.info('删除成功');
			// 		}
			// 	})
			// },
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.table.getData();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 722 ? 40 : 0);
			},
			modalCancel: function() {
				this.uploadList = []
				this.StationPicturesArray = []
				this.$nextTick(() => {
					this.$refs.AddUpForm.resetFields();
					console.log(this.$refs.AddUpForm);
					// this.$refs.upload.clearFiles();
					// this.defaultList = this.$refs.upload.fileList
				})
			},
			getUpdateMessage: function(OperatorId) {
				console.log("修改查看运营商方法OperatorId" + OperatorId);
				const _this = this;
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].OperatorId == OperatorId) {
						_this.StationForm = Object.assign({}, _this.data1[i])
						_this.StationPicturesArray = [];
						let PictureStr = _this.data1[i].LogoImg;
						let picList = []
						if (PictureStr != "") {
							_this.StationPicturesArray = PictureStr.split(",")
							for (let i = 0; i < _this.StationPicturesArray.length; i++) {
								let url = ''
								// if (process.env.NODE_ENV === "development") {
								// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+_this.StationPicturesArray[i];
								// }else {
								//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+_this.StationPicturesArray[i];
								// }
								url = webapi.base_api_url + _this.StationPicturesArray[i];
								let picture = {
									name: _this.StationPicturesArray[i],
									url: url
								}
								picList.push(picture)
							}
						}
						_this.defaultList = picList
						_this.$nextTick(() => {
							// dom元素更新后执行，因此这里能正确打印更改之后的值
							// _this.uploadList = _this.$refs.upload.fileList
						})
					}
				}
			},
			//新增||修改
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.IsEdit = false
						break;
					case "up":
						_this.StationForm.IsEdit = true
						let picsArr = _this.PictureUpCache
						if (picsArr.length > 0) {
							let StationPictures = ''
							for (let i = 0; i < picsArr.length; i++) {
								if (i == (picsArr.length - 1)) {
									StationPictures += picsArr[i]
								} else {
									StationPictures += picsArr[i] + ','
								}
							}
							_this.deletePicture(StationPictures)
						}
						break;
				}
				_this.PictureDelCache = [];
				_this.PictureUpCache = [];
				let picsArr = _this.StationPicturesArray
				_this.StationForm.LogoImg = ''
				for (let i = 0; i < picsArr.length; i++) {
					if (i == (picsArr.length - 1)) {
						_this.StationForm.LogoImg += picsArr[i]
					} else {
						_this.StationForm.LogoImg += picsArr[i] + ','
					}
				}
				const param = _this.StationForm
				_this.$refs.AddUpForm.validate((valid) => {
					console.log("场站" + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + '/Archives/AddOperator',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.info("运营商" + type + "成功");
								// _this.$refs.sonPage.getList();
								_this.$refs.table.getData();
								_this.modalView = false;
								_this.PictureDelCache = [];
								_this.GetTypeListDefine()
							} else {
								_this.$Message.info("运营商" + type + "失败:" + res.data.Data);
							}
						})
					}
				})
			},
			//地图modal
			// mapOpen: function() {
			// 	this.showMap = true;
			// 	gaodeMap.initMap("map", 10, this.center, 'normal');
			// 	gaodeMap.mapOn2(this);
			// },
			// closeMap: function() {
			// 	gaodeMap.map.destroy();
			// 	gaodeMap.map = '';
			// 	this.showMap = false;
			// },
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.info('删除成功');
						_this.PictureDelCache = []
						_this.handleSubmit()
					} else {
						_this.$Message.info('图片删除失败');
						_this.handleSubmit()
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')

				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				// const fileList = _this.$refs.upload.fileList;
				// _this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				// _this.$nextTick(() => {
				// 	// dom元素更新后执行，因此这里能正确打印更改之后的值
				// 	_this.uploadList = _this.$refs.upload.fileList
				// 	_this.defaultList = _this.$refs.upload.fileList
				// })
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					// if (process.env.NODE_ENV === "development") {
					// 	file.url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }else {
					//   file.url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '格式错误',
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '图片太大',
					desc: '文件' + file.name + ' 图片太大请选择小于 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.seflPoing .ivu-form-item-label:before {
		content: '*';
		display: inline-block;
		margin-right: 4px;
		line-height: 1;
		font-family: SimSun;
		font-size: 12px;
		color: #ed4014;
	}
</style>